import { withDevModalFilePath } from '../common';
import { EquipmentDetailView } from './EquipmentDetailView';

interface EquipmentDetailModalProps {
  open: boolean;
  equipmentId: string | null;
  onClose: () => void;
}

const { Modal } = withDevModalFilePath('client/src/components/equipment/EquipmentDetailModal.tsx');

export function EquipmentDetailModal({ open, equipmentId, onClose }: EquipmentDetailModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="90%"
      styles={{ body: { padding: 0 } }}
      destroyOnHidden
      centered
    >
      {equipmentId ? (
        <div style={{ padding: 24, maxHeight: '80vh', overflowY: 'auto' }}>
          <EquipmentDetailView equipmentId={equipmentId} mode="modal" onClose={onClose} />
        </div>
      ) : null}
    </Modal>
  );
}

